@if (crmPromoted) {
    <ms-promotion-badge />
}
@if (isInSheetView || !hideMarketHeader) {
    <ms-option-panel-header
        [groupType]="groupType"
        [optionGroup]="optionGroup"
        [showHelp]="showHelp"
        [toggleable]="toggleable && !isInSheetView"
        [promoted]="promoted"
        [collapsed]="collapsed"
        [event]="event"
        [showEventName]="showEventName"
        [activePeriodTab]="activePeriodTab"
        [showEventTimer]="showEventTimer"
        [isLinkToEvent]="isLinkToEvent"
        [marketLogoShow]="marketLogoShow"
        [showEventChevron]="showEventChevron && !isInSheetView"
        [shouldShowCloseBtn]="isInSheetView"
        [appendTooltipToWidgetSlot]="appendTooltipToWidgetSlot"
        (collapsedChange)="onHeaderToggle($event)"
        (eventTitleClicked)="onEventTitleClick()"
        (closeBtnClicked)="onCloseButtonClicked()"
        [(showMarketHelp)]="showMarketHelp"
        [(eventHelpText)]="eventHelpText" />
}

<ng-content />

<ms-performance-tracker [trigger]="event.id" />
<ng-container *rxIf="(showSuspendedSelection || optionGroup.online) && !collapsed && !hideOptions(); strategy: strategy$">
    <div class="option-panel-body">
        @switch (groupType) {
            @case (groupTypes.PlayerCombined) {
                <ms-player-combined-option-group
                    [event]="event"
                    [optionGroup]="optionGroup"
                    [tracking]="tracking"
                    [showMarketHelp]="showMarketHelp"
                    [crmPromoIdsMap]="crmPromoIdsMap"
                    [eventHelpText]="eventHelpText"
                    [sourceOfPick]="sourceOfPick"
                    [betDetails]="betDetails"
                    [optionsLimitOverride]="optionsLimitOverride"
                    [showPlayerStats]="showPlayerStats"
                    (showAllRequested)="openSheetView()" />
            }
            @case (groupTypes.PlayerOutcome) {
                <ms-player-outcome-option-group
                    [event]="event"
                    [optionGroup]="optionGroup"
                    [tracking]="tracking"
                    [showMarketHelp]="showMarketHelp"
                    [crmPromotedOptionIdsMap]="crmPromoIdsMap.options"
                    [eventHelpText]="eventHelpText"
                    [sourceOfPick]="sourceOfPick"
                    [betDetails]="betDetails" />
            }
            @case (groupTypes.PlayerMilestone) {
                <ms-player-milestone-option-group
                    [event]="event"
                    [optionGroup]="optionGroup"
                    [tracking]="tracking"
                    [trackingModuleType]="trackingModuleType"
                    [isShowTabs]="true"
                    [scrollAdapterButtonSize]="scrollAdapterButtonSize"
                    [showMarketHelp]="showMarketHelp"
                    [crmPromoIdsMap]="crmPromoIdsMap"
                    [sourceOfPick]="sourceOfPick"
                    [betDetails]="betDetails"
                    [optionsLimitOverride]="optionsLimitOverride"
                    [showPlayerStats]="showPlayerStats"
                    (showAllRequested)="openSheetView()" />
            }
            @case (groupTypes.PlayerMilestoneOverUnder) {
                <ms-player-milestone-over-under-option-group
                    [event]="event"
                    [optionGroup]="optionGroup"
                    [tracking]="tracking"
                    [trackingModuleType]="trackingModuleType"
                    [isShowTabs]="true"
                    [scrollAdapterButtonSize]="scrollAdapterButtonSize"
                    [showMarketHelp]="showMarketHelp"
                    [crmPromoIdsMap]="crmPromoIdsMap"
                    [sourceOfPick]="sourceOfPick"
                    [betDetails]="betDetails"
                    [optionsLimitOverride]="optionsLimitOverride"
                    [showPlayerStats]="showPlayerStats"
                    (showAllRequested)="openSheetView()" />
            }
            @case (groupTypes.PrecreatedBuildABet) {
                <ms-precreated-bab-option-group
                    [event]="event"
                    [fixtureId]="event.id"
                    [optionGroup]="optionGroup"
                    [tracking]="tracking"
                    [trackingModuleType]="trackingModuleType"
                    [showMarketHelp]="showMarketHelp"
                    [showMoreCounter]="showMoreCounter"
                    [optionsLimitOverride]="optionsLimitOverride"
                    [buttonSource]="babButtonSource"
                    [betBuilderEpcotEnabled]="betBuilderEpcotEnabled"
                    [hideBetBuilderButton]="hideBetBuilderButton"
                    (showAllRequested)="openSheetView()" />
            }
            @case (groupTypes.Period) {
                <ms-period-option-group
                    [event]="event"
                    [optionGroup]="optionGroup"
                    [thresholds]="thresholds"
                    [tracking]="tracking"
                    [trackingModuleType]="trackingModuleType"
                    [showMarketHelp]="showMarketHelp"
                    [crmPromoIdsMap]="crmPromoIdsMap"
                    [scrollAdapterButtonSize]="scrollAdapterButtonSize"
                    [sourceOfPick]="sourceOfPick"
                    [betDetails]="betDetails"
                    [optionsLimitOverride]="optionsLimitOverride"
                    [showSixPackLogosColor]="showSixPackLogosColor"
                    [showSixPackLogos]="showSixPackLogos"
                    [showPlayerStats]="showPlayerStats"
                    (activePeriodChange)="onActivePeriodChange($event)"
                    (showAllRequested)="openSheetView()" />
            }
            @case (groupTypes.Scorecast) {
                <ms-scorecast-option-group
                    [event]="event"
                    [optionGroup]="optionGroup"
                    [preselectedPick]="preselectedPick"
                    [tracking]="tracking"
                    [trackingModuleType]="trackingModuleType"
                    [showMarketHelp]="showMarketHelp"
                    [eventHelpText]="eventHelpText"
                    [sourceOfPick]="sourceOfPick"
                    [betDetails]="betDetails" />
            }
            @case (groupTypes.Wincast) {
                <ms-wincast-option-group
                    [event]="event"
                    [optionGroup]="optionGroup"
                    [tracking]="tracking"
                    [trackingModuleType]="trackingModuleType"
                    [showMarketHelp]="showMarketHelp"
                    [eventHelpText]="eventHelpText"
                    [sourceOfPick]="sourceOfPick"
                    [betDetails]="betDetails" />
            }
            @case ([groupTypes.Regular, groupTypes.USGroupedList].includes(groupType) ? groupType : !groupType) {
                <ms-regular-group
                    [event]="event"
                    [optionGroup]="optionGroup"
                    [groupType]="groupType"
                    [thresholds]="thresholds"
                    [tracking]="tracking"
                    [trackingModuleType]="trackingModuleType"
                    [calendarTrack]="calendarTitle"
                    [showMarketHelp]="showMarketHelp"
                    [crmPromotedOptionIdsMap]="crmPromoIdsMap.options"
                    [eventHelpText]="eventHelpText"
                    [linkableGroup]="optionGroupLinkable"
                    [sourceOfPick]="sourceOfPick"
                    [betDetails]="betDetails"
                    [optionsLimitOverride]="optionsLimitOverride"
                    [showPlayerStats]="showPlayerStats"
                    (expandClicked)="onExpandedClicked($event)"
                    (showAllRequested)="openSheetView()" />
            }
            @case (groupTypes.CorrectScore) {
                <ms-correct-score-option-group-wrapper
                    [event]="event"
                    [optionGroup]="optionGroup"
                    [isShowMoreDisabled]="!thresholds && !optionsLimitOverride"
                    [tracking]="tracking"
                    [trackingModuleType]="trackingModuleType"
                    [showMarketHelp]="showMarketHelp"
                    [crmPromotedOptionIdsMap]="crmPromoIdsMap.options"
                    [eventHelpText]="eventHelpText"
                    [sourceOfPick]="sourceOfPick"
                    [betDetails]="betDetails"
                    [optionsLimitOverride]="optionsLimitOverride" />
            }
            @case (groupTypes.OverUnder) {
                <ms-over-under-option-group
                    [event]="event"
                    [optionGroup]="optionGroup"
                    [tracking]="tracking"
                    [trackingModuleType]="trackingModuleType"
                    [showMarketHelp]="showMarketHelp"
                    [crmPromoIdsMap]="crmPromoIdsMap"
                    [eventHelpText]="eventHelpText"
                    [sourceOfPick]="sourceOfPick"
                    [betDetails]="betDetails"
                    [optionsLimitOverride]="optionsLimitOverride"
                    (showAllRequested)="openSheetView()" />
            }
            @case (groupTypes.GoalScorer) {
                <ms-goal-scorer-option-group
                    [event]="event"
                    [optionGroup]="optionGroup"
                    [isShowMoreDisabled]="!thresholds && !optionsLimitOverride"
                    [tracking]="tracking"
                    [trackingModuleType]="trackingModuleType"
                    [calendarTrack]="calendarTitle"
                    [showMarketHelp]="showMarketHelp"
                    [eventHelpText]="eventHelpText"
                    [sourceOfPick]="sourceOfPick"
                    [betDetails]="betDetails"
                    [optionsLimitOverride]="optionsLimitOverride"
                    (showAllRequested)="openSheetView()" />
            }
            @case (groupTypes.PlayerProps) {
                <ms-player-props-option-group
                    [event]="event"
                    [optionGroup]="optionGroup"
                    [trackingModuleType]="trackingModuleType"
                    [tracking]="tracking"
                    [showMarketHelp]="showMarketHelp"
                    [crmPromoIdsMap]="crmPromoIdsMap"
                    [eventHelpText]="eventHelpText"
                    [sourceOfPick]="sourceOfPick"
                    [betDetails]="betDetails"
                    [optionsLimitOverride]="optionsLimitOverride"
                    [showPlayerStats]="showPlayerStats"
                    (showAllRequested)="openSheetView()" />
            }
            @case (groupTypes.Spread) {
                <ms-spread-option-group
                    [event]="event"
                    [optionGroup]="optionGroup"
                    [tracking]="tracking"
                    [showMarketHelp]="showMarketHelp"
                    [trackingModuleType]="trackingModuleType"
                    [crmPromoIdsMap]="crmPromoIdsMap"
                    [eventHelpText]="eventHelpText"
                    [sourceOfPick]="sourceOfPick"
                    [betDetails]="betDetails"
                    [optionsLimitOverride]="optionsLimitOverride"
                    (showAllRequested)="openSheetView()" />
            }
            @case (groupTypes.WincastParticipant) {
                <ms-wincast-two-way-scorer-option-group
                    [event]="event"
                    [optionGroup]="optionGroup"
                    [preselectedPick]="preselectedPick"
                    [tracking]="tracking"
                    [showMarketHelp]="showMarketHelp"
                    [eventHelpText]="eventHelpText"
                    [trackingModuleType]="trackingModuleType"
                    [sourceOfPick]="sourceOfPick"
                    [betDetails]="betDetails" />
            }
            @case (groupTypes.SixPack) {
                <ms-six-pack-option-group
                    [event]="event"
                    [trackingModuleType]="trackingModuleType"
                    [optionGroup]="optionGroup"
                    [tracking]="tracking"
                    [showMarketHelp]="showMarketHelp"
                    [crmPromoIdsMap]="crmPromoIdsMap"
                    [eventHelpText]="eventHelpText"
                    [sourceOfPick]="sourceOfPick"
                    [betDetails]="betDetails"
                    [showLogoColor]="showSixPackLogosColor"
                    [showSixPackParticipantImages]="showSixPackLogos"
                    [showPlayerStats]="showPlayerStats" />
            }
            @case ([groupTypes.RaceTo, groupTypes.BTTS].includes(groupType) ? groupType : !groupType) {
                <ms-score-market-option-group
                    [event]="event"
                    [optionGroup]="optionGroup"
                    [groupType]="groupType"
                    [tracking]="tracking"
                    [trackingModuleType]="trackingModuleType"
                    [showMarketHelp]="showMarketHelp"
                    [crmPromoIdsMap]="crmPromoIdsMap"
                    [eventHelpText]="eventHelpText"
                    [sourceOfPick]="sourceOfPick"
                    [betDetails]="betDetails"
                    [optionsLimitOverride]="optionsLimitOverride" />
            }
            @case (groupTypes.Outrights) {
                <ms-outrights-option-group
                    [event]="event"
                    [optionGroup]="optionGroup"
                    [tracking]="tracking"
                    [showMarketHelp]="showMarketHelp"
                    [crmPromoIdsMap]="crmPromoIdsMap"
                    [eventHelpText]="eventHelpText"
                    [sourceOfPick]="sourceOfPick"
                    [trackingModuleType]="trackingModuleType"
                    [betDetails]="betDetails"
                    [optionsLimitOverride]="optionsLimitOverride" />
            }
            @case (groupTypes.YesNo) {
                <ms-yes-no-option-group
                    [event]="event"
                    [optionGroup]="optionGroup"
                    [tracking]="tracking"
                    [showMarketHelp]="showMarketHelp"
                    [crmPromoIdsMap]="crmPromoIdsMap"
                    [eventHelpText]="eventHelpText"
                    [sourceOfPick]="sourceOfPick"
                    [betDetails]="betDetails"
                    [optionsLimitOverride]="optionsLimitOverride"
                    [trackingModuleType]="trackingModuleType"
                    (showAllRequested)="openSheetView()" />
            }
            @case (groupTypes.TotalScore) {
                <ms-total-score-option-group
                    [trackingModuleType]="trackingModuleType"
                    [event]="event"
                    [optionGroup]="optionGroup"
                    [tracking]="tracking"
                    [showMarketHelp]="showMarketHelp"
                    [crmPromoIdsMap]="crmPromoIdsMap"
                    [sourceOfPick]="sourceOfPick"
                    [betDetails]="betDetails"
                    [optionsLimitOverride]="optionsLimitOverride" />
            }
            @case (groupTypes.Head2Head) {
                <ms-head-to-head-option-group
                    [event]="event"
                    [optionGroup]="optionGroup"
                    [tracking]="tracking"
                    [showMarketHelp]="showMarketHelp"
                    [crmPromoIdsMap]="crmPromoIdsMap"
                    [sourceOfPick]="sourceOfPick"
                    [betDetails]="betDetails" />
            }
            @case (groupTypes.BetBuilderStandard) {
                <ms-bet-builder-standard-group
                    [event]="event"
                    [optionGroup]="optionGroup"
                    [tracking]="tracking"
                    [trackingModuleType]="trackingModuleType"
                    [showMarketHelp]="showMarketHelp"
                    [eventHelpText]="eventHelpText"
                    [sourceOfPick]="sourceOfPick" />
            }
            @case (groupTypes.BetBuilderSixPack) {
                <ms-bet-builder-six-pack
                    [event]="event"
                    [optionGroup]="optionGroup"
                    [tracking]="tracking"
                    [trackingModuleType]="trackingModuleType"
                    [showMarketHelp]="showMarketHelp"
                    [crmPromoIdsMap]="crmPromoIdsMap"
                    [eventHelpText]="eventHelpText"
                    [sourceOfPick]="sourceOfPick" />
            }
            @case (groupTypes.BetBuilderOverUnder) {
                <ms-bet-builder-over-under-option-group
                    [event]="event"
                    [optionGroup]="optionGroup"
                    [tracking]="tracking"
                    [trackingModuleType]="trackingModuleType"
                    [showMarketHelp]="showMarketHelp"
                    [crmPromoIdsMap]="crmPromoIdsMap"
                    [eventHelpText]="eventHelpText"
                    [sourceOfPick]="sourceOfPick" />
            }
            @case (groupTypes.BetBuilderCorrectScore) {
                <ms-bet-builder-correct-score-option-group
                    [event]="event"
                    [optionGroup]="optionGroup"
                    [isShowMoreDisabled]="!thresholds"
                    [tracking]="tracking"
                    [trackingModuleType]="trackingModuleType"
                    [showMarketHelp]="showMarketHelp"
                    [crmPromotedOptionIdsMap]="crmPromoIdsMap.options"
                    [eventHelpText]="eventHelpText"
                    [sourceOfPick]="sourceOfPick"
                    [optionsLimitOverride]="optionsLimitOverride"
                    (showAllRequested)="openSheetView()" />
            }
            @case (groupTypes.BetBuilderSpread) {
                <ms-bet-builder-spread-option-group
                    [event]="event"
                    [optionGroup]="optionGroup"
                    [tracking]="tracking"
                    [trackingModuleType]="trackingModuleType"
                    [showMarketHelp]="showMarketHelp"
                    [crmPromoIdsMap]="crmPromoIdsMap"
                    [eventHelpText]="eventHelpText"
                    [sourceOfPick]="sourceOfPick" />
            }
            @case (groupTypes.BetBuilderRaceTo) {
                <ms-bet-builder-teams-option-group
                    [event]="event"
                    [optionGroup]="optionGroup"
                    [tracking]="tracking"
                    [trackingModuleType]="trackingModuleType"
                    [showMarketHelp]="showMarketHelp"
                    [crmPromoIdsMap]="crmPromoIdsMap"
                    [eventHelpText]="eventHelpText"
                    [sourceOfPick]="sourceOfPick" />
            }
            @case (groupTypes.BetBuilderGoalScorer) {
                <ms-bet-builder-goalscorer-option-group
                    [event]="event"
                    [optionGroup]="optionGroup"
                    [isShowMoreDisabled]="!thresholds"
                    [tracking]="tracking"
                    [trackingModuleType]="trackingModuleType"
                    [showMarketHelp]="showMarketHelp"
                    [eventHelpText]="eventHelpText"
                    [sourceOfPick]="sourceOfPick" />
            }
            @case (groupTypes.BetBuilderYesNo) {
                <ms-bet-builder-goalscorer-option-group
                    [event]="event"
                    [optionGroup]="optionGroup"
                    [isShowMoreDisabled]="!thresholds"
                    [tracking]="tracking"
                    [showMarketHelp]="showMarketHelp"
                    [trackingModuleType]="trackingModuleType"
                    [eventHelpText]="eventHelpText"
                    [sourceOfPick]="sourceOfPick" />
            }
            @case (groupTypes.BetBuilderPlayerProps) {
                <ms-bet-builder-goalscorer-option-group
                    [event]="event"
                    [optionGroup]="optionGroup"
                    [isShowMoreDisabled]="!thresholds"
                    [tracking]="tracking"
                    [trackingModuleType]="trackingModuleType"
                    [showMarketHelp]="showMarketHelp"
                    [eventHelpText]="eventHelpText"
                    [showMarketAttribute]="true"
                    [sourceOfPick]="sourceOfPick" />
            }
            @case (groupTypes.PlayerStats) {
                <ms-player-stats-option-group
                    [event]="event"
                    [optionGroup]="optionGroup"
                    [tracking]="tracking"
                    [trackingModuleType]="trackingModuleType"
                    [showMarketHelp]="showMarketHelp"
                    [eventHelpText]="eventHelpText"
                    [sourceOfPick]="sourceOfPick"
                    [betDetails]="betDetails"
                    [optionsLimitOverride]="optionsLimitOverride"
                    (showAllRequested)="openSheetView()" />
            }
        }
    </div>
</ng-container>
